import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { MdRefresh } from 'react-icons/md'
import { theme } from '../../../styles/theme.style'
import styles from './KioskWaiting.module.scss'

const KioskWaiting = ({ onlineStatus, deviceName }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.kioskWaiting}>
      <div className={styles.kioskWaiting__content}>
        <img
          src={theme.LOGO_WHITE}
          alt="TeleVU"
          className={styles.kioskWaiting__logo}
        />
        {deviceName && (
          <div className={styles.kioskWaiting__deviceName}>
            {deviceName}
          </div>
        )}
        <div className={styles.kioskWaiting__statusContainer}>
          <div
            className={`${styles.kioskWaiting__statusIndicator} ${
              onlineStatus
                ? styles['kioskWaiting__statusIndicator--online']
                : styles['kioskWaiting__statusIndicator--offline']
            }`}
          />
          <span className={styles.kioskWaiting__statusText}>
            {onlineStatus ? t('Online') : t('Connecting...')}
          </span>
        </div>
        <p className={styles.kioskWaiting__message}>
          {onlineStatus
            ? t('Waiting for call...')
            : t('Establishing connection...')}
        </p>
      </div>
      <button
        className={styles.kioskWaiting__refreshButton}
        onClick={() => window.location.reload()}
        aria-label={t('Refresh')}
      >
        <MdRefresh />
      </button>
    </div>
  )
}

KioskWaiting.propTypes = {
  onlineStatus: PropTypes.bool,
  deviceName: PropTypes.string
}

export default memo(KioskWaiting)
